<template>
  <div class="contents contents--list">
    <div class="contents--list-subject">
      <span>Convert wPCI to PCI (unwrap)</span>
    </div>

    <div class="input-box">
      <div class="input-inner-box">
        <div class="option">
          <label>Deposit Address (PCI)</label>
          <input class="address-field" type="text" placeholder="Input your PCI address." v-model="depositAddress"/>
        </div>
        <div class="option">
          <label>Amount (wPCI)</label>
          <input class="amount-field" type="text" v-model="amountValue" @keyup.enter="isModalViewed = true"/>
          <button @click="isModalViewed = true">CONVERT</button>
        </div>
        <div class="contents--description">
          <span>● <span class="highlight">wPCI unwrap 시, 코빗(korbit) 거래소의 페이코인(PCI) 지갑만 지원합니다. </span>페이코인 앱 주소 및 2차 주소(MEMO)가 있는 거래소 등 코빗(korbit) 거래소가 아닌 곳의 지갑 주소를 입력 할 경우, 입금 및 복구가 불가능합니다. </span><br>
          <span>● <span class="highlight">When unwrapping wPCI, only the Paycoin (PCI) wallet from Korbit exchange is supported.</span> If you enter a wallet address from an exchange other than Korbit, such as an address from the Paycoin app or an exchange that uses a secondary address (MEMO), deposits and recovery will not be possible.</span>
        </div>
      </div>
    </div>

    <div class="contents__detail-box" v-if="!noResults">
      <div class="contents--list-subject">
        <span>Check your transaction</span>
      </div>
      <div class="flexBox" v-if="loading">
        <RotateLoader :loading="loading" color="#0393f4" size="13px"/>
      </div>
      <Table v-if="!noResults && !loading" width="900px" data-type="unwrap" :data="resultData"/>
      <div class="contents--description">
        <span>■ 안내사항 (Guidelines)</span><br>
        <span>1. Unwrapping은 일정 시간 후에 완료되며, 결과는 페이코인 앱에서 확인할 수 있습니다.</span><br>
        <span>2. 페이지를 새로고침 하거나 이동하면 Unwrapping 정보를 확인 할 수 없으니 중요한 정보는 메모하거나 스크린샷으로 저장 해주세요.</span><br>
        <span>3. 결과 페이지를 벗어나도 Unwrapping 과정은 무효화되지 않습니다.</span><br><br>
        <span>1. Unwrapping will be completed after a certain period, you may check the results in your Paycoin app.</span><br>
        <span>2. If you refresh or leave the result page, you won't be able to view the Unwrapping result. Please take a note or a screenshot to save the important information.</span><br>
        <span>3. Leaving the results page does not invalidate the Unwrapping process.</span><br>
      </div>
    </div>

    <ModalView v-if="isModalViewed" @close-modal="isModalViewed = false">
      <div class="contents__modal">
        <div class="contents--list-subject">
          <span>Confirm your conversion</span>
        </div>
        <div class="contents--description">
          <span>Please carefully check the amount to convert,
              from/to chain, and deposit address.</span>
        </div>

        <div class="contents--content">
          <div class="contents--list-subject">
            <span>From Ethereum Chain</span>
          </div>
          <div class="contents--list-content">
            <span>{{ this.amountValue }}</span><span class="unit">wPCI</span>
          </div>
          <div class="contents--list-subject">
            <span>Deposit Address</span>
          </div>
          <div class="contents--list-content">
            <div class="item">
              <span>{{ this.depositAddress }}</span>
            </div>
          </div>
          <div class="contents--description">
            <span>● <span class="highlight">wPCI unwrap 시, 코빗(korbit) 거래소의 페이코인(PCI) 지갑만 지원합니다.</span> 페이코인 앱 주소 및 2차 주소(MEMO)가 있는 거래소 등 코빗(korbit) 거래소가 아닌 곳의 지갑 주소를 입력 할 경우, 입금 및 복구가 불가능합니다.</span>
          </div>
          <div class="contents--description">
            <span>● <span class="highlight">When unwrapping wPCI, only the Paycoin (PCI) wallet from Korbit exchange is supported.</span> If you enter a wallet address from an exchange other than Korbit, such as an address from the Paycoin app or an exchange that uses a secondary address (MEMO), deposits and recovery will not be possible.</span>
          </div>
        </div>
        <div class="btn_wrap">
          <button class="btn btn__cancel" @click="isModalViewed = false">CANCEL</button>
          <button class="btn btn__confirm" @click="doUnwrap">CONFIRM</button>
        </div>
      </div>
    </ModalView>
    <ModalView v-if="isValiedViewed" @close-modal="isValiedViewed = false">
      <div class="contents__modal">
        <div class="contents--list-subject">
          <span>● wPCI 언랩시, 해당 지갑 주소는 지원하지 않습니다. 다시 한번 확인 해주세요.</span>
        </div>
        <div class="contents--list-subject">
          <span>● wPCI Unwrap, we don't support that wallet address, please double check.</span>
        </div>
        <div class="content-btn-center">
          <button class="btn btn__validconfirm" @click="isValiedViewed = false">CONFIRM</button>
        </div>
      </div>
    </ModalView>
  </div>
</template>

<script>
import Table from "./shared/Table.vue";
import ModalView from "./shared/ModalView.vue";
import RotateLoader from "./shared/RotateLoader.vue";
import {styleNav} from "../../js/style";
import {ABI, tokenAddress} from "../../js/wpci";
import callAPI from "../../api/http";

export default {
  name: "Unwrap",

  components: {
    Table,
    ModalView,
    RotateLoader,
  },

  async created() {
    await this.getEthInfo();
  },

  mounted() {
    styleNav(5);
  },

  data() {
    return {
      web3: undefined,
      contract: undefined,
      isModalViewed: false,
      isValiedViewed: false,
      isAddressValid: false,
      noResults: true,
      loading: false,
      depositAddress: "",
      amountValue: "",
      resultData: [
        {field: 'Ethereum Account', value: ""},
        {field: 'PayProtocol Account', value: ""},
        {field: 'From Ethereum Chain (wPCI)', value: ""},
        {field: 'To PayProtocol Network (PCI)', value: ""},
        {field: 'Ethereum TX HASH', value: ""},
      ],
    };
  },

  methods: {
    async getEthInfo() {
      if (window.ethereum) {
        await window.ethereum.request({method: 'eth_requestAccounts'});
        this.web3 = new Web3(window.ethereum);
        this.contract = new this.web3.eth.Contract(ABI, tokenAddress);
      } else if (window.web3) {
        this.web3 = new Web3(window.web3.currentProvider);
        this.contract = new this.web3.eth.Contract(ABI, tokenAddress);
      } else {
        alert('You have to install MetaMask !');
      }
    },

    async doUnwrap() {
      const accounts = await this.web3.eth.getAccounts();
      const address = this.depositAddress;
      const amount = this.amountValue * Math.pow(10, 8);

      // console.log("dounwrap")
      const {data, errCode} = await callAPI("getAddressCheck", address);
      // issuer가 bithumb 또는 Coinone이면 data는 false
      if (data) {
        this.contract.methods.unwrap(address, amount).send({
          from: accounts[0]
        }).on('transactionHash', () => {
          this.isModalViewed = false;
          this.noResults = false;
          this.loading = true;
        }).on('receipt', (receipt) => {
          this.resultData[0].value = receipt.events.Unwrapped.returnValues[0];
          this.resultData[1].value = receipt.events.Unwrapped.returnValues[2];
          this.resultData[2].value = receipt.events.Unwrapped.returnValues[1] * Math.pow(10, -8);
          this.resultData[3].value = receipt.events.Unwrapped.returnValues[1] * Math.pow(10, -8);
          this.resultData[4].value = receipt.events.Unwrapped.transactionHash;
          this.loading = false;
        }).on('error', (error) => {
          //console.log("error: ", error)
          this.loading = false;
          this.noResults = true;
        })
      } else {
        this.isModalViewed = false;
        this.isValiedViewed = true;

      }
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../scss/common";

.input-box {
  overflow-x: auto;
}

.input-inner-box {
  min-width: 550px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 10px 0;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  margin-top: 15px;

  .option {
    display: flex;
    align-items: center;
  }

  .option label {
    width: 180px;
    font-size: 13px;
    font-weight: 700;
  }

  input {
    width: 450px;
    height: 25px;
    box-sizing: border-box;
    padding-left: 8px;
    border-radius: 10px;
    border: 1px solid #ebebeb;
    font-size: 13px;
    outline: none;
  }

  button {
    width: 140px;
    margin-left: 10px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 10px;
    background-color: #0393f4;
    color: #FFF;
    cursor: pointer;
  }

  .amount-field {
    width: 300px;
  }
}

.btn_wrap {
  margin: auto;
}

.flexBox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.contents__modal {
  margin: 25px;
}

.contents--content {
  margin: 30px 0;
}

.contents--description {
  margin: 10px 0;
  font-size: 12px;
  white-space: pre-line;
}

.contents--list-content {
  margin: 10px 0;
  min-height: 39px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 8px;
  border-radius: 10px;
  border: 1px solid #ebebeb;
  font-size: 13px;
  word-wrap: break-word;
  outline: none;

  .unit {
    font-weight: 700;
  }

  .item {
    min-width: 0;
  }
}

.content-btn-center {
  text-align: center;
}

.btn {
  width: 168px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom : 15px;
  margin-top :30px;



  &__cancel {
    float: left;
  }

  &__confirm {
    float: right;
    background-color: #0393f4;
    color: #FFF;
  }

  &__mini {
    width: 170px;
  }

  &__validconfirm {
    display: inline-block;
  }
}
.highlight {
  color: red; /* 색상을 빨간색으로 변경 */
}
</style>



// WEBPACK FOOTER //
// src/components/contents/Unwrap.vue